import { Info } from 'lucide-react'
import { useWorkwiseSelection } from '@/hooks/useWorkwiseSelection'
import styles from '@/pages/NewDeploymentPage.module.css'

/** Step 1: shown when WorkWise is selected or just cleared the other products. Same look as the page's notices. */
export function WorkwiseSelectionNotice() {
  const { message } = useWorkwiseSelection()
  if (!message) return null
  return (
    <div className={styles.approvalNotice} role="status" data-testid="workwise-selection-notice" style={{ marginBottom: 16 }}>
      <Info size={14} />
      {message}
    </div>
  )
}
